__turbopack_context__.v({
  "arrow": "LensCard-module__8avVdW__arrow",
  "body": "LensCard-module__8avVdW__body",
  "card": "LensCard-module__8avVdW__card",
  "eyebrow": "LensCard-module__8avVdW__eyebrow",
  "focus": "LensCard-module__8avVdW__focus",
  "glyph": "LensCard-module__8avVdW__glyph",
  "headline": "LensCard-module__8avVdW__headline",
  "index": "LensCard-module__8avVdW__index",
  "insight": "LensCard-module__8avVdW__insight",
  "pill": "LensCard-module__8avVdW__pill",
  "pillText": "LensCard-module__8avVdW__pillText",
  "q": "LensCard-module__8avVdW__q",
  "qMark": "LensCard-module__8avVdW__qMark",
  "questions": "LensCard-module__8avVdW__questions",
  "sep": "LensCard-module__8avVdW__sep",
  "slot": "LensCard-module__8avVdW__slot",
  "toggle": "LensCard-module__8avVdW__toggle",
  "try": "LensCard-module__8avVdW__try",
});
